import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';

import { catchError, Observable, throwError } from 'rxjs';

import { AUTH_KEY, AuthService } from '@pp/core/auth-store';
/**
 * Auth key interceptor
 */
@Injectable()
export class AuthKeyInterceptor implements HttpInterceptor {
  readonly #injector = inject(Injector);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.#addAuthKey(request)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.error?.error_code === '101') {
          const auth = this.#injector.get(AuthService);
          auth.logout();
        }

        return throwError(() => error);
      }),
    );
  }
  /**
   * Add auth key to request if token is present
   * @param request request
   */
  #addAuthKey(request: HttpRequest<any>): HttpRequest<any> {
    const authKey = globalThis.localStorage.getItem(AUTH_KEY);

    return authKey ? request.clone({ setHeaders: { Key: `${authKey}` } }) : request;
  }
}
